import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { st, classes } from './image.st.css';
import { ImageStatus, FALLBACK_IMAGE } from './consts';
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getSrc = function () {
            return _this.props.src ? _this.props.src : _this.getSrcSet();
        };
        _this.getSrcSet = function () {
            return _this.props.srcSet ? _this.getErrorImage() : FALLBACK_IMAGE;
        };
        _this.getErrorImage = function () {
            return _this.props.errorImage ? _this.props.errorImage : FALLBACK_IMAGE;
        };
        _this.getErrorSrc = function () {
            return _this.state.src === _this.props.errorImage
                ? FALLBACK_IMAGE
                : _this.getErrorImage();
        };
        _this.isErrorState = function () {
            return _this.state.status === ImageStatus.error;
        };
        _this.isResized = function () {
            return _this.props.resizeMode === 'contain' || _this.props.resizeMode === 'cover';
        };
        _this.state = {
            src: _this.getSrc(),
            status: ImageStatus.loading,
        };
        _this.handleOnLoad = function (e) {
            if (!_this.isErrorState()) {
                _this.setState({
                    status: _this.state.status === 'error'
                        ? ImageStatus.error
                        : ImageStatus.loaded,
                });
                _this.props.onLoad && _this.props.onLoad(e);
            }
        };
        _this.handleOnError = function (e) {
            if (!_this.isErrorState()) {
                _this.setState({
                    status: ImageStatus.error,
                    src: _this.getErrorSrc(),
                });
                _this.props.onError && _this.props.onError(e);
            }
        };
        return _this;
    }
    Image.prototype.getImageProps = function () {
        var _a = this.props, errorImage = _a.errorImage, resizeMode = _a.resizeMode, srcSet = _a.srcSet, nativeProps = _a.nativeProps, nativeRef = _a.nativeRef, additionalProps = __rest(_a, ["errorImage", "resizeMode", "srcSet", "nativeProps", "nativeRef"]);
        var ret = __assign(__assign(__assign({}, additionalProps), nativeProps), { ref: nativeRef, src: this.state.src, srcSet: this.isErrorState() ? null : srcSet, onLoad: this.handleOnLoad, onError: this.handleOnError });
        return ret;
    };
    Image.prototype.render = function () {
        var _a = this.props, resizeMode = _a.resizeMode, className = _a.className;
        var commonProps = {
            className: st(classes.root, { resizeMode: this.props.resizeMode, loadState: this.state.status }, this.isResized() ? ' wrapper' : '', className),
            'data-load-state': this.state.status,
        };
        if (this.isResized()) {
            var imageWrapper = {
                backgroundImage: "url(\"" + this.state.src + "\")",
                backgroundSize: resizeMode,
            };
            return (React.createElement("div", __assign({}, commonProps, { style: imageWrapper }),
                React.createElement("img", __assign({}, this.getImageProps()))));
        }
        return React.createElement("img", __assign({}, commonProps, this.getImageProps()));
    };
    return Image;
}(React.PureComponent));
export { Image };
//# sourceMappingURL=image.js.map